import moment from "moment";
import { ScheduleFrequency } from "PFApp/booking/types/export_booking";
import ConfirmModal, { ConfirmModalHeader } from "PFComponents/confirm/confirm_modal";
import MultiToggle from "PFComponents/multi_toggle";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useExportWizardModalContext } from "../../../../export_wizard_modal_provider";
import { MonthlyInterval, MonthlySelector } from "./monthly_selector";
import css from "./schedule_settings_modal.module.scss";
import { WeeklySelector } from "./weekly_selector";

const DEFAULT_FREQUENCY_VALUES = {
  [ScheduleFrequency.No]: null,
  [ScheduleFrequency.Daily]: null,
  [ScheduleFrequency.Weekly]: moment().format("dddd"),
  [ScheduleFrequency.Monthly]: MonthlyInterval.Day
};

export const ScheduleSettingsModal = (): JSX.Element => {
  const { t } = useTranslation(["bookingModule", "translation"]);
  const {
    state: {
      data: {
        schedule: { frequency, value }
      }
    },
    updateData
  } = useExportWizardModalContext();

  const [localValue, setLocalValue] = useState<string | null>(value);
  const [localFrequency, setLocalFrequency] = useState<ScheduleFrequency>(frequency);

  const handleOK = () => {
    updateData({ schedule: { frequency: localFrequency, value: localValue } });

    handleClose();
  };

  const handleClose = () => {
    updateData({ modals: { scheduleSettingsOpen: false } });
  };

  const handleChange = (id: ScheduleFrequency) => {
    setLocalFrequency(id);
    setLocalValue(DEFAULT_FREQUENCY_VALUES[id]);
  };

  return (
    <ConfirmModal
      handleOK={frequency ? handleOK : undefined}
      labelOK={t("translation:save")}
      handleClose={handleClose}
    >
      <ConfirmModalHeader className={css.header}>
        {t("bookingModule:reports.exportWizard.scheduleSettingsModalTitle")}
      </ConfirmModalHeader>

      <p className={css.label}>{t("bookingModule:reports.exportWizard.scheduleSettingsLabel")}</p>
      <MultiToggle
        classes={{ container: css.frequencySelector }}
        options={Object.values(ScheduleFrequency).map((frequency) => ({
          id: frequency.toString(),
          value: t(`bookingModule:reports.frequency.${frequency}`)
        }))}
        defaultSelected={frequency}
        onChange={handleChange}
      />

      {localFrequency === ScheduleFrequency.Weekly && (
        <WeeklySelector value={localValue} onChange={setLocalValue} />
      )}
      {localFrequency === ScheduleFrequency.Monthly && (
        <MonthlySelector value={localValue} onChange={setLocalValue} />
      )}
    </ConfirmModal>
  );
};
